module.exports = `${require.publicPath}southbay-sm.270fa91d.webp`;